import moment from "moment"

export const getParkAreas = (area: any) => {
    
    return area.map(function(ele: any){
    let newID
    if(ele.includes("Frederiksø")){
        newID = 3
    }
    if(ele.includes("Alle betalingspladser i zone 2")){
        newID = 2
        //ele = "Alle betalingspladser i zone 2 (Frederiksø, P-Huset, Voldgade, Frederiksgade og Jessens Mole)"
    }
    if(ele.includes("Zone 3 (Frederiksø og Voldgade)")){
        newID = 1
    }
    if(ele.includes("Voldgade og Rådhusgården")){
        newID = 0
    }
    if(newID == undefined){
        return {id: 0, area: ele}
    }else{
        return {id: newID, area: ele}
    }
    })
}

export const getLivingAreas = (area: any) => {

    return area.map(function(ele: any){
        let newID
        if(ele.includes("Område A")){
            newID = 0
        }
        if(ele.includes("Område B")){
            newID = 1
        }
        if(ele.includes("Område C")){
            newID = 2
        }
        if(ele.includes("Område D")){
            newID = 3
        }
        if(ele.includes("Område E")){
            newID = 4
        }
        if(newID == undefined){
            return {id: 0, area: ele}
        }else{
            return {id: newID, area: ele}
        }
        })
}

export const getCraftmanArea = (area: any) => {

    return area.map(function(ele: any){
        let newID
        if (ele.includes("Betalingspladser samt tidsbegrænsede p-pladser med 1 time eller mere")){
            newID = 0
        }
        if(newID == undefined){
            return {id: 0, area: ele}
        }else{
            return {id: newID, area: ele}
        }
    })
}

export const getDispensionAreas = (area: any) => {

    return area.map(function(ele: any) {
        let newID

        if (ele.includes("Kørselstilladelse Møllergade")){
            newID = 0
            ele = "Kørselstilladelse Møllergade, Krøyersstræde, Klosterstræde"
        }
        if (ele.includes("Kørselstilladese Torvet")){
            newID = 1
        }
        if (ele.includes("Kørselstilladelse Gåsestræde")){
            newID = 2
        }
        if (ele.includes("Arbejdskørsel og parkering - angiv sted i note")){
            newID = 3
        }
        if (ele.includes("Af- og pålæsning - angiv sted i note")){
            newID = 4
        }
        if (ele.includes("Parkering - angiv sted i note")){
            newID = 5
        }
        if (ele.includes("Flytning - angiv sted i note")){
            newID = 6
        }
        if (ele.includes("Andet - angiv i note")){
            newID = 7
        }
        
        if(newID == undefined){
            return {id: 0, area: ele}
        }else{
            return {id: newID, area: ele}
        }
    })
}

export const getConventionAreas = (area: any) => {
    
    return area.map(function(ele: any){
    let newID
    if(ele.includes("Jessens Mole kl.")){
        newID = 0
    }
    if(ele.includes("Jessens Mole med parkering")){
        newID = 1
    }
    if(ele.includes("Møllergade kl.")){
        newID = 2
    }
    if(ele.includes("Møllergade med parkering")){
        newID = 3
    }
    if(ele.includes("Tinghusgade kl.")){
        newID = 4
    }
    if(ele.includes("Tinghusgade med parkering")){
        newID = 5
    }
    if(ele.includes("Havnepladsen kl.")){
        newID = 6
    }
    if (ele.includes("Havnepladsen med parkering")){
        newID = 7
    }
    if(ele.includes("Frederiksgade kl.")){
        newID = 8
    }
    if(ele.includes("Frederiksgade med parkering")){
        newID = 9
    }
    if(ele.includes("Ryttervej kl.")){
        newID = 10
    }
    if(ele.includes("Ryttervej med parkering")){
        newID = 11
    }
    if(ele.includes("Christiansminde kl.")){
        newID = 12
    }
    if(ele.includes("Christiansminde med parkering")){
        newID = 13
    }
    if(ele.includes("Sofielund Skovvej kl.")){
        newID = 14
    }
    if(ele.includes("Sofielund Skovvej med parkering")){
        newID = 15
    }
    if(ele.includes("Tipsvænget kl.")){
        newID = 16
    }
    if(ele.includes("Tipsvænget med parkering")){
        newID = 17
    }
    if(ele.includes("Parkering uden for afspærringen")){
        newID = 18
    }
    if(ele.includes("Andet")){
        newID = 19
        ele = "Andet - angiv i note"
    }
    if(newID == undefined){
        return {id: 0, area: ele}
    }else{
        return {id: newID, area: ele}
    }
    })
}

enum ConventionDays {
    Monday = 1 << 0, // 1
    Tuesday = 1 << 1, // 2
    Wednesday = 1 << 2, // 4
    Thursday = 1 << 3, // 8
    Friday = 1 << 4, // 16
    Saturday = 1 << 5, // 32
    Sunday = 1 << 6, // 64
    Other = 1 << 7, // 128
}

function isDaySet(day: ConventionDays, val: number) {
    return Boolean(day & val);
}

export const renderPeriodDayType = (type: number) => {
    switch (type) {
        case 0: return "days"
        case 1: return "weeks"
        case 2: return "months"
        case 3: return "years"
        case 4: return "years"
    }
}

export const getLicenseStatus = (licensRow: any, currentLicens: number, modCurrentLicens: number | null, statusType: number, licensFromDate: Date | null, amountOfDays: number, typeOfPeriod: number ) => {
    let licensCheck
    let rowId = licensRow.id

    if (typeof rowId === "string"){ // The Total is a string, when its totalled
        return ""
    }

    if(modCurrentLicens != null){
        licensCheck = modCurrentLicens
    }
    else{
        licensCheck = currentLicens
    }

    let processedStatus 
    let lastEventDay // becomes the enddate
    let momentLastDate
    let curMomentDate = moment(new Date())

    if (licensCheck === 4 ){
        if (isDaySet(ConventionDays.Monday, typeOfPeriod)){
            lastEventDay = new Date(2022, 5, 27)
        }
        if (isDaySet(ConventionDays.Tuesday, typeOfPeriod)){
            lastEventDay = new Date(2022, 5, 28)
        }
        if (isDaySet(ConventionDays.Wednesday, typeOfPeriod)){
            lastEventDay = new Date(2022, 5, 29)
        }
        if (isDaySet(ConventionDays.Thursday, typeOfPeriod)){
            lastEventDay = new Date(2022, 5, 30)
        }
        if (isDaySet(ConventionDays.Friday, typeOfPeriod)){
            lastEventDay = new Date(2022, 6, 1)
        }
        if (isDaySet(ConventionDays.Saturday, typeOfPeriod)){
            lastEventDay = new Date(2022, 6, 2)
        }
        if (isDaySet(ConventionDays.Sunday, typeOfPeriod)){
            lastEventDay = new Date(2022, 6, 3)
        }
        if (isDaySet(ConventionDays.Other, typeOfPeriod)){
            lastEventDay = new Date(2022, 6, 3)
        }
        momentLastDate = moment(lastEventDay)
    }
    else{
        const dayType = renderPeriodDayType(typeOfPeriod)
        let momentDate = moment(licensFromDate)
        momentDate = momentDate.add(amountOfDays, dayType)
        if (licensRow.endDate) {
            momentLastDate = moment(licensRow.endDate)
        }
        else{
            momentLastDate = momentDate
        }
        
    }

    if (statusType === 4 && (moment(licensFromDate).isBefore(curMomentDate) && moment(momentLastDate).isAfter(curMomentDate)) ){ // checks if the status is active
        processedStatus = 7
    }
    else if (statusType === 4 && moment(curMomentDate).isAfter(momentLastDate) ) {
        processedStatus = 6
    }
    else{
        processedStatus = statusType
    }

    if (statusType === 3 && licensCheck === 4){
        if (moment(licensFromDate).isBefore(curMomentDate) && moment(momentLastDate).isAfter(curMomentDate)){
            processedStatus = 7
        }
        else{
            processedStatus = 4
        }
    }

    switch (processedStatus) {
        case 0: return "Modtaget"   // New status
        case 1: return "Under behandling" // processing
        case 2: return "Afvist" // Rejected
        case 3: return "Afventer betaling" // Waiting for payment
        case 4: return "Betalt" // Paid
        case 5: return "Annulleret" // canceled, 
        case 6: return "Udløbet" // Expired
        case 7: return "Aktiv" // licens is active
    }
    return "?"
}
